{
  "checkedAt": "2026-10-15",
  "scope": "NOAA owned and partnership-operated fleet plus explicitly documented data partners",
  "entries": [
    {
      "id": "goes16",
      "name": "GOES-16 (GOES-R)",
      "noradId": 41866,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "GOES",
      "orbitType": "GEO",
      "status": "On-orbit storage / backup",
      "instruments": [
        "ABI",
        "GLM",
        "EXIS",
        "SUVI",
        "SEISS",
        "MAG"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://ospo.noaa.gov/operations/goes/status.html",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/goes-east-west/goes-r-series-spacecraft-instruments"
      ],
      "template": "goes",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "goes17",
      "name": "GOES-17 (GOES-S)",
      "noradId": 43226,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "GOES",
      "orbitType": "GEO",
      "status": "On-orbit storage / backup",
      "instruments": [
        "ABI",
        "GLM",
        "EXIS",
        "SUVI",
        "SEISS",
        "MAG"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://ospo.noaa.gov/operations/goes/status.html",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/goes-east-west/goes-r-series-spacecraft-instruments"
      ],
      "template": "goes",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "goes18",
      "name": "GOES-18 (GOES-T)",
      "noradId": 51850,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "GOES",
      "orbitType": "GEO",
      "status": "GOES West",
      "instruments": [
        "ABI",
        "GLM",
        "EXIS",
        "SUVI",
        "SEISS",
        "MAG"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://ospo.noaa.gov/operations/goes/status.html",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/goes-east-west/goes-r-series-spacecraft-instruments"
      ],
      "template": "goes",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "goes19",
      "name": "GOES-19 (GOES-U)",
      "noradId": 60133,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "GOES",
      "orbitType": "GEO",
      "status": "GOES East",
      "instruments": [
        "ABI",
        "GLM",
        "EXIS",
        "SUVI",
        "SEISS",
        "MAG",
        "CCOR-1"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://ospo.noaa.gov/operations/goes/status.html",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/goes-east-west/goes-r-series-spacecraft-instruments"
      ],
      "template": "spacecraft_goes_u",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "noaa20",
      "name": "NOAA-20 (JPSS-1)",
      "noradId": 43013,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "JPSS",
      "orbitType": "LEO",
      "status": "Secondary JPSS polar satellite",
      "instruments": [
        "VIIRS",
        "CrIS",
        "ATMS",
        "OMPS",
        "CERES FM6"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/joint-polar-satellite-system/jpss-satellite-and-instruments",
        "https://www.ospo.noaa.gov/data/messages/2024/03/MSG_20240312_1430.html",
        "https://ceres.larc.nasa.gov/instruments/"
      ],
      "template": "spacecraft_jpss1",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "noaa21",
      "name": "NOAA-21 (JPSS-2)",
      "noradId": 54234,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "JPSS",
      "orbitType": "LEO",
      "status": "Primary JPSS polar satellite",
      "instruments": [
        "VIIRS",
        "CrIS",
        "ATMS",
        "OMPS"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/joint-polar-satellite-system/jpss-satellite-and-instruments",
        "https://www.ospo.noaa.gov/data/messages/2024/03/MSG_20240312_1430.html"
      ],
      "template": "noaa21",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "solar1",
      "name": "SOLAR-1 (formerly SWFO-L1)",
      "noradId": null,
      "role": "NOAA owned",
      "agency": "NOAA",
      "family": "Solar / L1",
      "orbitType": "L1",
      "status": "Primary SWPC solar-wind source",
      "instruments": [
        "SWiPS",
        "STIS",
        "MAG",
        "CCOR-2"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/future-programs/swfo/solar-1-instruments",
        "https://www.spaceweather.gov/news/solar-wind-data-and-display-changes"
      ],
      "template": "spacecraft_solar1",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "dscovr",
      "name": "DSCOVR",
      "noradId": 40390,
      "role": "NOAA owned",
      "agency": "NOAA / NASA / USAF",
      "family": "Solar / L1",
      "orbitType": "L1",
      "status": "Listed in NOAA fleet; SWPC solar-wind ingest ended June 2026",
      "instruments": [
        "EPIC",
        "NISTAR",
        "PlasMag"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/dscovr-deep-space-climate-observatory",
        "https://www.spaceweather.gov/news/solar-wind-data-and-display-changes"
      ],
      "template": "dscovr",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "suomi_npp",
      "name": "Suomi NPP (S-NPP)",
      "noradId": 37849,
      "role": "Partnership operated",
      "agency": "NOAA / NASA",
      "family": "JPSS",
      "orbitType": "LEO",
      "status": "Tertiary polar satellite; remaining science / HRD cessation scheduled 2 Nov 2026, 13:00 UTC",
      "instruments": [
        "VIIRS",
        "CrIS (operational use ended 23 Dec 2025)",
        "ATMS",
        "OMPS",
        "CERES FM5"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/joint-polar-satellite-system/jpss-satellite-and-instruments",
        "https://www.ospo.noaa.gov/data/messages/2026/10/MSG_20261001_1828.html"
      ],
      "template": "suomi_npp",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "jason3",
      "name": "Jason-3",
      "noradId": 41240,
      "role": "Partnership operated",
      "agency": "NOAA / NASA / CNES / EUMETSAT",
      "family": "Jason",
      "orbitType": "LEO",
      "status": "Listed in NOAA partnership-operated fleet",
      "instruments": [
        "Poseidon-3B",
        "AMR",
        "DORIS",
        "GPSP",
        "LRA"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/jason-3/jason-3-spacecraft-instruments"
      ],
      "template": "senseSat_01",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "dmsp_f16",
      "name": "DMSP F16",
      "noradId": 28054,
      "role": "Partnership operated",
      "agency": "US defense / NOAA operations",
      "family": "DMSP",
      "orbitType": "LEO",
      "status": "Listed in NOAA partnership-operated fleet; product availability varies by instrument",
      "instruments": [
        "OLS",
        "SSMIS",
        "SSJ",
        "SSIES",
        "SSM"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.ncei.noaa.gov/products/dmsp-data-availability",
        "https://star.nesdis.noaa.gov/mirs/ssmis.php"
      ],
      "template": "spacecraft_dmsp5d3",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "dmsp_f17",
      "name": "DMSP F17",
      "noradId": 29522,
      "role": "Partnership operated",
      "agency": "US defense / NOAA operations",
      "family": "DMSP",
      "orbitType": "LEO",
      "status": "Listed in NOAA partnership-operated fleet; product availability varies by instrument",
      "instruments": [
        "OLS",
        "SSMIS",
        "SSJ",
        "SSIES",
        "SSM"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.ncei.noaa.gov/products/dmsp-data-availability",
        "https://star.nesdis.noaa.gov/mirs/ssmis.php"
      ],
      "template": "spacecraft_dmsp5d3",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "dmsp_f18",
      "name": "DMSP F18",
      "noradId": 35951,
      "role": "Partnership operated",
      "agency": "US defense / NOAA operations",
      "family": "DMSP",
      "orbitType": "LEO",
      "status": "Listed in NOAA partnership-operated fleet; product availability varies by instrument",
      "instruments": [
        "OLS",
        "SSMIS",
        "SSJ",
        "SSIES",
        "SSM"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.ncei.noaa.gov/products/dmsp-data-availability",
        "https://star.nesdis.noaa.gov/mirs/ssmis.php"
      ],
      "template": "spacecraft_dmsp5d3",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "ews_g2",
      "name": "EWS-G2 (formerly GOES-15)",
      "noradId": 36411,
      "role": "Partnership operated",
      "agency": "US Space Force / NOAA operations",
      "family": "EWS",
      "orbitType": "GEO",
      "status": "Listed in NOAA partnership-operated fleet",
      "instruments": [
        "Imager",
        "Sounder"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://celestrak.org/norad/elements/table.php?FORMAT=tle&GROUP=goes",
        "https://repository.library.noaa.gov/view/noaa/1192/noaa_1192_DS1.pdf"
      ],
      "template": "spacecraft_goes_nop",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "ews_g3",
      "name": "EWS-G3 (formerly GOES-14)",
      "noradId": 35491,
      "role": "Partnership operated",
      "agency": "US Space Force / NOAA operations",
      "family": "EWS",
      "orbitType": "GEO",
      "status": "Listed in NOAA partnership-operated fleet",
      "instruments": [
        "Imager",
        "Sounder"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://celestrak.org/norad/elements/table.php?FORMAT=tle&GROUP=goes",
        "https://repository.library.noaa.gov/view/noaa/1192/noaa_1192_DS1.pdf"
      ],
      "template": "spacecraft_goes_nop",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_1",
      "name": "COSMIC-2 FM1 (FORMOSAT-7-1)",
      "noradId": 44349,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_2",
      "name": "COSMIC-2 FM2 (FORMOSAT-7-2)",
      "noradId": 44351,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_3",
      "name": "COSMIC-2 FM3 (FORMOSAT-7-3)",
      "noradId": 44343,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_4",
      "name": "COSMIC-2 FM4 (FORMOSAT-7-4)",
      "noradId": 44350,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_5",
      "name": "COSMIC-2 FM5 (FORMOSAT-7-5)",
      "noradId": 44358,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "cosmic2_6",
      "name": "COSMIC-2 FM6 (FORMOSAT-7-6)",
      "noradId": 44353,
      "role": "Data partner",
      "agency": "Taiwan / US COSMIC-2 partnership",
      "family": "COSMIC-2",
      "orbitType": "LEO",
      "status": "Atmospheric and ionospheric GNSS radio-occultation constellation member",
      "instruments": [
        "TGRS",
        "IVM",
        "RF beacon"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
        "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft"
      ],
      "template": "spacecraft_cosmic2",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "gazelle",
      "name": "GAzelle (Argos-4 host / OTB-3)",
      "noradId": 54023,
      "role": "Data partner",
      "agency": "General Atomics host / CNES Argos-4 / NOAA",
      "family": "Argos",
      "orbitType": "LEO",
      "status": "Commercial spacecraft hosting the Argos-4 environmental data-collection payload",
      "instruments": [
        "Argos-4 (hosted payload)"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying/argos-4-launch"
      ],
      "template": "spacecraft_gazelle",
      "model": "Mission/family exterior reconstruction",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    },
    {
      "id": "ace",
      "name": "ACE",
      "noradId": 24912,
      "role": "Data partner",
      "agency": "NASA; NOAA SWPC data user",
      "family": "Solar / L1",
      "orbitType": "L1",
      "status": "SWPC backup solar-wind source (June 2026 notice)",
      "instruments": [
        "MAG",
        "SWEPAM",
        "EPAM",
        "SIS",
        "CRIS",
        "ULEIS",
        "SWICS",
        "SWIMS",
        "SEPICA (historical)"
      ],
      "checkedAt": "2026-10-15",
      "sources": [
        "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
        "https://science.nasa.gov/mission/ace/",
        "https://www.spaceweather.gov/news/solar-wind-data-and-display-changes"
      ],
      "template": "ace",
      "model": "Mission/family reference",
      "planningNote": "Antenna assignments, priorities and traffic targets are planning assumptions, not verified operational schedules or NOAA service commitments."
    }
  ],
  "sources": {
    "fleet": "https://www.nesdis.noaa.gov/our-satellites/currently-flying",
    "goes": "https://ospo.noaa.gov/operations/goes/status.html",
    "goesPayload": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/goes-east-west/goes-r-series-spacecraft-instruments",
    "jpss": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/joint-polar-satellite-system/jpss-satellite-and-instruments",
    "primary": "https://www.ospo.noaa.gov/data/messages/2024/03/MSG_20240312_1430.html",
    "npp": "https://www.ospo.noaa.gov/data/messages/2026/10/MSG_20261001_1828.html",
    "solar": "https://www.nesdis.noaa.gov/our-satellites/future-programs/swfo/solar-1-instruments",
    "solarWind": "https://www.spaceweather.gov/news/solar-wind-data-and-display-changes",
    "dscovr": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/dscovr-deep-space-climate-observatory",
    "jason": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/jason-3/jason-3-spacecraft-instruments",
    "dmsp": "https://www.ncei.noaa.gov/products/dmsp-data-availability",
    "ssmis": "https://star.nesdis.noaa.gov/mirs/ssmis.php",
    "ews": "https://celestrak.org/norad/elements/table.php?FORMAT=tle&GROUP=goes",
    "legacyGoes": "https://repository.library.noaa.gov/view/noaa/1192/noaa_1192_DS1.pdf",
    "cosmic": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/cosmic-2",
    "cosmicPayload": "https://www.nesdis.noaa.gov/current-satellite-missions/currently-flying/cosmic-2/cosmic-2-spacecraft",
    "argos": "https://www.nesdis.noaa.gov/our-satellites/currently-flying/argos-4-launch",
    "ace": "https://science.nasa.gov/mission/ace/",
    "ceres": "https://ceres.larc.nasa.gov/instruments/"
  },
  "antennaNote": "The 41 configured antennas are a planning inventory, not a certified current operational station roster.",
  "excluded": "Retired POES and EWS-G1 excluded. Other international missions remain in Extended Earth-observation planning."
}
